import {
    GET_SYSTEM_DEFAULT_LIST,
    GET_SYSTEM_USER_CONNFIC_DETAILS,
    GET_SYSTEM_USER_WEEKOFF_DETAILS,
    GET_SYSTEM_USER_LEAVE_DETAILS,
    GET_SUMMARY_CONNFIC_DETAILS
} from '../constants';

const initialState = {
    options: [],
    configDetails: {},
    weekConfig: {},
    leaveConfig: {},
    isSummary:false,
    screenVisible: false,
    showLoading: false,
};

export function SystemDefaultReducer(state = initialState, action) {

    if (action.type === GET_SYSTEM_DEFAULT_LIST) {
        return {
            ...state,
            options: action.payload.data,
            screenVisible: true,
            showLoading: false,
        };
    }

    if (action.type === GET_SYSTEM_USER_CONNFIC_DETAILS) {
        return {
            ...state,
            configDetails: action.payload.data,
        };
    }

    if (action.type === GET_SYSTEM_USER_WEEKOFF_DETAILS) {
        return {
            ...state,
            weekConfig: action.payload.data,
        };
    }

    if (action.type === GET_SYSTEM_USER_LEAVE_DETAILS) {
        return {
            ...state,
            leaveConfig: action.payload.data,
        };
    }
   if (action.type === GET_SUMMARY_CONNFIC_DETAILS) {
        return {
            ...state,
            isSummary: action.payload?.view_summary??false,
        };
    }
    return state;
}


